import { CHANNEL_TYPES, PROVIDER_TYPES, PROVIDER_TO_CHANNEL_MAP } from '@root/src/vars/general'
import { COMM_CONTROL_PROVIDER_TYPES } from '../constants'

export function getCommChannelKind(connector) {
    const provider = connector?.providerType || ''
    const connectorType = connector?.connectorType || ''

    if (
        !COMM_CONTROL_PROVIDER_TYPES.includes(provider) ||
        connectorType !== PROVIDER_TO_CHANNEL_MAP[provider]
    ) {
        return null
    }

    if ([PROVIDER_TYPES.whatsappBasis, PROVIDER_TYPES.whatsappApi, PROVIDER_TYPES.whatsappDh].includes(provider)) {
        return 'wa'
    }
    if ([PROVIDER_TYPES.telegramApi, PROVIDER_TYPES.telegramDh].includes(provider)) {
        return 'tg'
    }
    if (provider === PROVIDER_TYPES.maxBasis) {
        return 'max'
    }

    return null
}

export function getCommBaseNameByKind(kind) {
    if (kind === 'wa') return 'WhatsApp'
    if (kind === 'tg') return 'Telegram'
    return 'MAX'
}

export function getCommBgByKind(kind) {
    if (kind === 'wa') return '#29a71a'
    if (kind === 'tg') return '#23a8e9'
    return '#7B57D4'
}

export function getCommMdiByKind(kind) {
    if (kind === 'wa') return 'mdi-whatsapp'
    if (kind === 'tg') return 'mdi-telegram'
    return 'mdi-alpha-m-box'
}

export function getCommAvatarTypeByKind(kind) {
    if (kind === 'wa') return CHANNEL_TYPES.whatsappChannel
    if (kind === 'tg') return CHANNEL_TYPES.telegramChannel
    return CHANNEL_TYPES.maxChannel
}

export function getCommControlDescription(controlCount) {
    if (!controlCount) {
        return 'Контроль не подключён'
    }
    const suffix = controlCount === 1 ? 'номере' : 'номерах'
    return `Контроль на ${controlCount} ${suffix}`
}

export function buildCommChannels({ connectors, commControlPhonesByConnector, connectorsAvatars }) {
    const allowedConnectors = connectors
        .filter(connector => connector?.isActive !== false)
        .map(connector => ({ connector, kind: getCommChannelKind(connector) }))
        .filter(item => Boolean(item.kind))

    const countsByKind = { wa: 0, tg: 0, max: 0 }
    const avatars = connectorsAvatars || []

    return allowedConnectors.map(({ connector, kind }) => {
        countsByKind[kind] += 1
        const channelIndex = countsByKind[kind]
        const id = String(connector.connectorId || connector.id)
        const avatarType = getCommAvatarTypeByKind(kind)
        const avatar = avatars.find(item => item.type === avatarType) || {}
        const controlCount = (commControlPhonesByConnector[id] || []).length
        const baseName = getCommBaseNameByKind(kind)
        return {
            id,
            displayName: channelIndex === 1 ? baseName : `${baseName} ${channelIndex}`,
            bg: getCommBgByKind(kind),
            mdiIcon: getCommMdiByKind(kind),
            image: avatar.image || null,
            controlCount,
            controlDescription: getCommControlDescription(controlCount),
        }
    })
}
